module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/babel-runtime@6.26.0/~/babel-runtime/core-js/symbol.js
// module id = 123
// module chunks = 1 2 3